module.exports = __webpack_public_path__ + "static/media/raphael.1da03e44.jpg";